export const getValue = (val, key) => {
  if (val) {
    return { [key]: val }
  }
  return null
}
